import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <p>&copy; {currentYear} Brinary. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
